import React, {ComponentType, ReactNode} from "react";
import {SerializedStyles} from "@emotion/react";

import {IIcon} from "@pg-design/icons-module";

interface IProps {
    icon: ComponentType<IIcon>;
    children: ReactNode;
    containerStyle?: SerializedStyles;
    iconProps?: {
        size?: string;
        wrapperColor?: string;
        wrapperSize?: string;
        wrapperType?: "circle" | "square";
    };
}

export const IconWithElement = (props: IProps) => {
    const {containerStyle, iconProps} = props;
    const Icon = props.icon;

    return (
        <div css={containerStyle}>
            <Icon {...iconProps} />

            {props.children}
        </div>
    );
};
import React, {ComponentType, ReactNode} from "react";
import {SerializedStyles} from "@emotion/react";

import {IIcon} from "@pg-design/icons-module";

interface IProps {
    icon: ComponentType<IIcon>;
    children: ReactNode;
    containerStyle?: SerializedStyles;
    iconProps?: {
        size?: string;
        wrapperColor?: string;
        wrapperSize?: string;
        wrapperType?: "circle" | "square";
    };
}

export const IconWithElement = (props: IProps) => {
    const {containerStyle, iconProps} = props;
    const Icon = props.icon;

    return (
        <div css={containerStyle}>
            <Icon {...iconProps} />

            {props.children}
        </div>
    );
};
